export default __webpack_public_path__ + "static/media/_IMG5669.937ee7a0.jpg";